import { login } from "../../js/api/auth.js";
import Header from "../../views/components/Header.js";
import TranslationService, { _t } from "../../services/TranslationService.js";
import {
  checkForUserGroup,
  transformRepeatBet,
} from "../../services/UserGroup.js";
import { LOGIN_PROTECTED } from "../../js/constants/global-variables.js";

let Login = {
  render: async () => {
    const currentLang = localStorage.getItem("lang");

    let view = `<div class="loginModal">
       <div class="loginModalWrapper">
         <div class="inputHolder">
           <input type="text" name="loginUsername" id="login-username" placeholder="${_t("Perdoruesi")}">
           <a class="clearUsername hideElement">
             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path></svg>
           </a>
         </div>
         <div class="inputHolder">
           <input type="password" name="loginPassword" id="login-password" placeholder="${_t("Fjalekalimi")}">
           <a class="passwordVisible">
             <svg class="showPassword hideElement" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 511.992 511.992" style="enable-background:new 0 0 511.992 511.992;" xml:space="preserve">
                <g>
                \t<g>
                \t\t<path d="M510.096,249.937c-4.032-5.867-100.928-143.275-254.101-143.275C124.56,106.662,7.44,243.281,2.512,249.105    c-3.349,3.968-3.349,9.792,0,13.781C7.44,268.71,124.56,405.329,255.995,405.329S504.549,268.71,509.477,262.886    C512.571,259.217,512.848,253.905,510.096,249.937z M255.995,383.996c-105.365,0-205.547-100.48-230.997-128    c25.408-27.541,125.483-128,230.997-128c123.285,0,210.304,100.331,231.552,127.424    C463.013,282.065,362.256,383.996,255.995,383.996z"></path>
                \t</g>
                </g>
                <g>
                \t<g>
                \t\t<path d="M255.995,170.662c-47.061,0-85.333,38.272-85.333,85.333s38.272,85.333,85.333,85.333s85.333-38.272,85.333-85.333    S303.056,170.662,255.995,170.662z M255.995,319.996c-35.285,0-64-28.715-64-64s28.715-64,64-64s64,28.715,64,64    S291.28,319.996,255.995,319.996z"></path>
                \t</g>
                </g>
              </svg>
             <svg class="hidePassword hideElement" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
                <g>
                \t<g>
                \t\t<path d="M316.332,195.662c-4.16-4.16-10.923-4.16-15.083,0c-4.16,4.16-4.16,10.944,0,15.083    c12.075,12.075,18.752,28.139,18.752,45.248c0,35.285-28.715,64-64,64c-17.109,0-33.173-6.656-45.248-18.752    c-4.16-4.16-10.923-4.16-15.083,0c-4.16,4.139-4.16,10.923,0,15.083c16.085,16.128,37.525,25.003,60.331,25.003    c47.061,0,85.333-38.272,85.333-85.333C341.334,233.187,332.46,211.747,316.332,195.662z"></path>
                \t</g>
                </g>
                <g>
                \t<g>
                \t\t<path d="M270.87,172.131c-4.843-0.853-9.792-1.472-14.869-1.472c-47.061,0-85.333,38.272-85.333,85.333    c0,5.077,0.619,10.027,1.493,14.869c0.917,5.163,5.419,8.811,10.475,8.811c0.619,0,1.237-0.043,1.877-0.171    c5.781-1.024,9.664-6.571,8.64-12.352c-0.661-3.627-1.152-7.317-1.152-11.157c0-35.285,28.715-64,64-64    c3.84,0,7.531,0.491,11.157,1.131c5.675,1.152,11.328-2.859,12.352-8.64C280.534,178.702,276.652,173.155,270.87,172.131z"></path>
                \t</g>
                </g>
                <g>
                \t<g>
                \t\t<path d="M509.462,249.102c-2.411-2.859-60.117-70.208-139.712-111.445c-5.163-2.709-11.669-0.661-14.379,4.587    c-2.709,5.227-0.661,11.669,4.587,14.379c61.312,31.744,110.293,81.28,127.04,99.371c-25.429,27.541-125.504,128-230.997,128    c-35.797,0-71.872-8.64-107.264-25.707c-5.248-2.581-11.669-0.341-14.229,4.971c-2.581,5.291-0.341,11.669,4.971,14.229    c38.293,18.496,77.504,27.84,116.523,27.84c131.435,0,248.555-136.619,253.483-142.443    C512.854,258.915,512.833,253.091,509.462,249.102z"></path>
                \t</g>
                </g>
                <g>
                \t<g>
                \t\t<path d="M325.996,118.947c-24.277-8.171-47.829-12.288-69.995-12.288c-131.435,0-248.555,136.619-253.483,142.443    c-3.115,3.669-3.371,9.003-0.597,12.992c1.472,2.112,36.736,52.181,97.856,92.779c1.813,1.216,3.84,1.792,5.888,1.792    c3.435,0,6.827-1.664,8.875-4.8c3.264-4.885,1.92-11.52-2.987-14.763c-44.885-29.845-75.605-65.877-87.104-80.533    c24.555-26.667,125.291-128.576,231.552-128.576c19.861,0,41.131,3.755,63.189,11.157c5.589,2.005,11.648-1.088,13.504-6.699    C334.572,126.862,331.585,120.825,325.996,118.947z"></path>
                \t</g>
                </g>
                <g>
                \t<g>
                \t\t<path d="M444.865,67.128c-4.16-4.16-10.923-4.16-15.083,0L67.116,429.795c-4.16,4.16-4.16,10.923,0,15.083    c2.091,2.069,4.821,3.115,7.552,3.115c2.731,0,5.461-1.045,7.531-3.115L444.865,82.211    C449.025,78.051,449.025,71.288,444.865,67.128z"></path>
                \t</g>
                </g>
              </svg>
           </a>
         </div>
         <span class="errorDesc"></span>
         <a class="loginAuthBtn" id="loginAuthBtn">${_t("Identifikohu")}</a>

        <select id="login_language_switch_login" class="login_language_switch">
        ${TranslationService.languages
          .map((lang) => {
            return `<option value="${lang.key}" ${lang.key === currentLang ? "selected" : ""}>${lang.name}</option>`;
          })
          .concat("")}
        </select>
       </div>
     </div>
        `;
    return view;
  },
  after_render: async () => {
    const loginBtn = document.getElementById("loginAuthBtn");
    const input = document.getElementById("login-password");
    if (loginBtn) {
      loginBtn.addEventListener("click", async () => {
        const username = document.getElementById("login-username").value;
        const password = document.getElementById("login-password").value;
        var loginResult = await login(username, password);
        if (loginResult && loginResult.jwt) {
          localStorage.setItem("user_id", loginResult.user.id);
          localStorage.setItem("access_token", loginResult.jwt);
          localStorage.setItem("name", loginResult.user.name);
          localStorage.setItem("surname", loginResult.user.surname);
          localStorage.setItem("role", loginResult.user.role);
          localStorage.setItem("slotId", loginResult.user.slot_id);
          localStorage.setItem("username", username);
          localStorage.setItem("chatToken", loginResult.user.chatToken);
          localStorage.setItem("slotEnabled", loginResult.user.slotEnabled);
          localStorage.setItem("starGameId", loginResult.user.stargame_id);
          localStorage.setItem(
            "starCasinoEnabled",
            loginResult.user.starCasinoEnabled === "1",
          );

          if (loginResult.login_response) {
            localStorage.setItem(
              "casinoEnabled",
              loginResult.login_response.casinoEnabled,
            );
            localStorage.setItem(
              "virtualEnabled",
              loginResult.login_response.virtualEnabled,
            );
            localStorage.setItem(
              "starCasinoEnabled",
              loginResult.login_response.starCasinoEnabled,
            );
            localStorage.setItem(
              "liveCasinoEnabled",
              loginResult.login_response.liveCasinoEnabled,
            );
            localStorage.setItem(
              "vipCasinoEnabled",
              loginResult.login_response.vipCasinoEnabled,
            );
          }

          if (loginResult.user.id == "17101") {
            localStorage.setItem("superAdminGames", loginResult.user.id);
          } else {
            localStorage.setItem(
              "superAdminGames",
              loginResult.user.superadmin,
            );
          }

          if (loginResult.user.has_gsdeluxe === "1") {
            localStorage.setItem("hasDeluxe", true);
          }

          $("body").removeClass("modalIsShown");
          $("body .loginModal").removeClass("clicked");
          const userGroup = await checkForUserGroup();
          if (userGroup) {
            // Update existing games saved on localstorage
            let games = JSON.parse(localStorage.getItem("addObject")) || [];
            if (games.length) {
              games = transformRepeatBet(games);
              localStorage.setItem("addObject", JSON.stringify(games));
            }
            window.location.reload();
          }
          const header = null || document.getElementById("header_container");
          header.innerHTML = await Header.render();
          await Header.after_render();

          // initChat();
        }
        if (loginResult.errors) {
          $("body .errorDesc").text(loginResult.message);
        }
      });
    }

    $(".loginModal input").on("keyup", function () {
      $("body .errorDesc").text("");
    });

    $(".clearUsername").on("click", function () {
      $("body .errorDesc").text("");
    });
    input.addEventListener("keyup", function (event) {
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        // Cancel the default action, if needed
        // Trigger the button element with a click
        document.getElementById("loginAuthBtn").click();
      }
    });

    $("#login_language_switch_login").on("change", (event) => {
      TranslationService.setLanguage(event.target.value);
    });

    $(".clearUsername").addClass("hideElement");
    $(".hidePassword").addClass("hideElement");
    $(".showPassword").addClass("hideElement");

    $("body .loginBtn").on("click", function () {
      $("body").addClass("modalIsShown");
      $("body .loginModal").addClass("clicked");
    });

    // if (!localStorage.getItem("access_token")) {
    //   $("body .loginBtn").click();
    // }

    // $('body').on('click', '.loginAuthBtn', function(){
    //   alert('.loginAuthBtn is clicked on loginHandler.js');
    // });

    $(".clearUsername").on("click", function () {
      $(".inputHolder input[name=loginUsername]").val("");
      $(this).addClass("hideElement");
    });

    $(".inputHolder input[name=loginUsername]").keyup(function () {
      let elementSelcted = $("input[name=loginUsername]");
      if ($(elementSelcted).val() == "") {
        $(".clearUsername").addClass("hideElement");
      } else {
        $(".clearUsername").removeClass("hideElement");
      }
    });
    $(".inputHolder input[name=loginPassword]").keyup(function () {
      let elementSelcted = $("input[name=loginPassword]");
      if ($(elementSelcted).val() == "") {
        $(".hidePassword").addClass("hideElement");
        $(".showPassword").addClass("hideElement");
      } else {
        if ($("input[name=loginPassword]").attr("type") == "password") {
          $(".hidePassword").addClass("hideElement");
          $(".showPassword").removeClass("hideElement");
        } else {
          $(".hidePassword").removeClass("hideElement");
          $(".showPassword").addClass("hideElement");
        }
      }
    });

    $(".showPassword").on("click", function () {
      $(".inputHolder input[name=loginPassword]").attr("type", "text");
      $(this).addClass("hideElement");
      $(".hidePassword").removeClass("hideElement");
    });

    $(".hidePassword").on("click", function () {
      $(".inputHolder input[name=loginPassword]").attr("type", "password");
      $(this).addClass("hideElement");
      $(".showPassword").removeClass("hideElement");
    });

    // $(document).mouseup(function(e){
    //     var container = $(".loginModalWrapper");
    //     if(!container.is(e.target) && container.has(e.target).length === 0){
    //         $('.loginModal').removeClass('clicked');
    //         $('body').removeClass('modalIsShown');
    //     }
    // });

    if (LOGIN_PROTECTED === true && !localStorage.getItem("access_token")) {
      $('#loginBtn').click();
    }

    if (window.location.host === 'ultrabet.uno') {
      $('#login_language_switch_login option').not('[value="it"]').remove();
      $('#login_language_switch_footer option').not('[value="it"]').remove();
      setTimeout(() => {
        $('#login_language_switch_login option').not('[value="it"]').remove();
        $('#login_language_switch_footer option').not('[value="it"]').remove();
      }, 2000);
    }
  },
};

export default Login;
